<section class="trust-area pt-100 pb-70">
    <div class="container">
        <div class="section-title" appReveal>
            <h2>Why Blink</h2>
        </div>

        <div class="trust-content why-blink-content">
            <div *ngIf="whyBlinkLoading" class="row">
                <div class="col-12 col-lg-4" *ngFor="let item of whyBlinkSkeletonItems">
                    <div class="service-item mb-30 skeleton">
                        <div class="service-inner">
                            <div class="why-blink-icon-skeleton"></div>
                            <h3 class="skeleton-text skeleton-title">&nbsp;</h3>
                            <p class="skeleton-text skeleton-desc">&nbsp;</p>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="!whyBlinkLoading && whyBlinkError" class="row">
                <div class="col-12">
                    <div class="service-feedback service-error">
                        <strong>Unable to load Why Blink content.</strong>
                        <span>{{ whyBlinkError }}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="!whyBlinkLoading && !whyBlinkError && whyBlinkItems.length === 0" class="row">
                <div class="col-12">
                    <div class="service-feedback service-empty">
                        No Why Blink items were returned from WordPress. Add items under WordPress and refresh this page.
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="!whyBlinkLoading && !whyBlinkError && whyBlinkItems.length > 0">
                <div class="col-12 col-lg-4" *ngFor="let item of whyBlinkItems; trackBy: trackByWhyBlink; let i = index"
                    appReveal revealVariant="card" [revealDelay]="i * 90">
                    <div class="service-item mb-30">
                        <div class="service-inner">
                            <img *ngIf="item.iconUrl" class="why-blink-icon" [src]="item.iconUrl" [alt]="item.title" />
                            <h3>{{ item.title }}</h3>
                            <p *ngIf="item.description">{{ item.description }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-center pt-3">
                <a routerLink="/contact" class="btn cta-btn">Plan Your Shoot In Oman</a>
            </div>
        </div>
    </div>
</section>

<section class="service-area service-area-two pt-100 pb-70 fixer-services-section">
    <div class="container">
        <div class="section-title" appReveal>
            <h2>Fixer Services</h2>
        </div>

        <div *ngIf="fixerServicesLoading" class="row">
            <div class="col-sm-6 col-lg-4" *ngFor="let item of fixerServicesSkeletonItems">
                <div class="service-item skeleton">
                    <i class="bx bx-loader-alt"></i>
                    <div class="service-inner">
                        <h3 class="skeleton-text skeleton-title">&nbsp;</h3>
                        <p class="skeleton-text skeleton-desc">&nbsp;</p>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!fixerServicesLoading && fixerServicesError" class="row">
            <div class="col-12">
                <div class="service-feedback service-error">
                    <strong>Unable to load Fixer Services.</strong>
                    <span>{{ fixerServicesError }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="!fixerServicesLoading && !fixerServicesError && fixerServices.length === 0" class="row">
            <div class="col-12">
                <div class="service-feedback service-empty">
                    No Fixer Services were returned from WordPress. Add items under WordPress and refresh this page.
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!fixerServicesLoading && !fixerServicesError && fixerServices.length > 0">
            <div class="col-sm-6 col-lg-4" *ngFor="let item of fixerServices; trackBy: trackByFixerService; let i = index"
                appReveal revealVariant="card" [revealDelay]="i * 80">
                <div class="service-item">
                    <img *ngIf="item.iconUrl; else fixerServiceIconFallback" class="fixer-service-icon" [src]="item.iconUrl" [alt]="item.title" />
                    <ng-template #fixerServiceIconFallback>
                        <i [ngClass]="getFixerServiceIconClass(item, i)"></i>
                    </ng-template>
                    <div class="service-inner">
                        <h3>{{ item.title }}</h3>
                        <p *ngIf="item.description">{{ item.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>